export const MAX_WIDTH = 42; // eslint-disable-line import/prefer-default-export
